import { render } from "./ModalConfirm.vue?vue&type=template&id=53b8967a&ts=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=ts"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__